// removed by extract-text-webpack-plugin
module.exports = {"overlay":"L_XH_YhNx72zBFXUxmt_M","transparent":"_1Y06gqpSBn0u7D_NZF1bKv","loader":"_1k_4k7_meI3wHahas2TYRx","message":"_1V5LVMawQ6RSIquW3_g7UM"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43a4e8a0","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/loading-overlay/loading-overlay.less
// module id = XUiI
// module chunks = 1